import { FunctionComponent } from 'react'
import useStyles from '@/modules/Auth/components/ProfileCard/profile-card-style'
import { Avatar } from '@conexasaude/hero'

interface PropsProfileCard {
  className?: string
  name: string
  clinic: string
  photo: string
  type: string
}

const ProfileCard: FunctionComponent<PropsProfileCard> = ({
  className,
  name,
  clinic,
  photo,
  type,
}) => {
  const styles = useStyles()

  return (
    <div className={className} css={styles.profileCard}>
      <div className="itens_card">
        <div className="avatar_card">
          <Avatar alt="" size="md" src={photo} />
        </div>
        <div className="text_card">
          <h5 className="name_card text-capitalize">{name.toLowerCase()}</h5>
          <div className="clinic_card">{clinic}</div>
          <div className="box_perfil">
            <div className="details_card">Perfil:</div>
            <div>{type}</div>
          </div>
        </div>
      </div>
    </div>
  )
}

export default ProfileCard
